// removed by extract-text-webpack-plugin
module.exports = {"wrapper-checkbox":"magazines_3myQT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/styles.scss
// module id = 1038
// module chunks = 1